import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../utils/api';

const initialState = {
  shops: [],
  loading: false,
  error: null,
};

export const fetchShops = createAsyncThunk(
  'shops/fetchShops',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/shops');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addShop = createAsyncThunk(
  'shops/addShop',
  async (shopData, { rejectWithValue }) => {
    try {
      const response = await api.post('/shops', shopData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateShop = createAsyncThunk(
  'shops/updateShop',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/shops/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteShop = createAsyncThunk(
  'shops/deleteShop',
  async (shopId, { rejectWithValue }) => {
    try {
      await api.delete(`/shops/${shopId}`);
      return shopId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const shopsSlice = createSlice({
  name: 'shops',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchShops.pending, (state) => { state.loading = true; })
      .addCase(fetchShops.fulfilled, (state, action) => {
        state.loading = false;
        state.shops = action.payload;
      })
      .addCase(fetchShops.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add
      .addCase(addShop.fulfilled, (state, action) => {
        state.shops.push(action.payload);
      })
      // Update
      .addCase(updateShop.fulfilled, (state, action) => {
        const index = state.shops.findIndex(s => s.id === action.payload.id);
        if (index !== -1) state.shops[index] = action.payload;
      })
      // Delete
      .addCase(deleteShop.fulfilled, (state, action) => {
        state.shops = state.shops.filter(s => s.id !== action.payload);
      });
  },
});

export default shopsSlice.reducer;
